define('models/order/product/product',['backbone'], function (Backbone) {
    var product = Backbone.Model.extend({
        initialize: function (options) {
            options = options || {};
            this.requestBody = options.requestBody;
        },
        verifySecureAuth: function (callback) {
            callback = callback || {};

            var that = this;

            $.ajax({
                async: false,
                type: 'GET',
                url: pf.authURL + "/Token/CheckFin",
                contentType: "application/json",
                success: function (resp, model) {
                    callback(resp);
                },
                error: function (resp, model) { }
            });

        },
        orderProduct: function (callback) {
            var that = this;
            callback = callback || {};

            var userGUID = pf.session.get("UserGUID");

            this.verifySecureAuth(function (isSecure) {
                if (isSecure) {
                    var config = pf.apigconfig.orderProduct;
                    var apigClient = apigClientFactory.newClient({
                        apiKey: pf.apikey,
                        invokeUrl: config.invokeUrl,
                        endpointPath: config.endpointPath,
                        method: config.method
                    });
                    var params = that.requestBody;
                    var body = that.requestBody;
                    var additionalParams = {
                        headers: {
                            Authorization: userGUID
                        },
                        queryParams: {}
                    };

                    apigClient.makeRequest(params, body, additionalParams)
                        .then(function (result) {
                            if (callback)
                                return callback(null, result);
                            else
                                return result;
                        })
                        .catch(function (err) {
                            if (callback)
                                return callback(err);
                            else
                                return err;
                        });
                }
            });
        }
    });

    return product;
});


